// ✅ نسخه کامل فرم بارداری با فرم آزمایش، محاسبه پویا، نمایش سوابق، و به‌روزرسانی GA بالا:

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import moment from "moment-jalaali";

moment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

const toEnglishNumber = (str) => {
  if (!str) return "";
  const fa = "۰۱۲۳۴۵۶۷۸۹";
  const en = "0123456789";
  return str.replace(/[۰-۹]/g, (w) => en[fa.indexOf(w)]);
};

const toPersianNumber = (str) => {
  if (!str) return "";
  const en = "0123456789";
  const fa = "۰۱۲۳۴۵۶۷۸۹";
  return str.replace(/\d/g, (d) => fa[en.indexOf(d)]);
};

export const Pregnancy = () => {
  const location = useLocation();
  const propsData = location.state;

  const [pregnancies, setPregnancies] = useState([]);
  const [form, setForm] = useState({
    lmp: null,
    l: "",
    ab: "",
    p: "",
    g: "",
    note: "",
    hof: "",
    bp: "",
    wt: "",
    date: null,
    type: "",
    gender: "",
    fht:"",
  });
  const [gaEdc, setGaEdc] = useState({ ga_weeks: "", edc: "" });
  const [currentGa, setCurrentGa] = useState("");
  const [labData, setLabData] = useState({});
  const [labHistory, setLabHistory] = useState([]);

  useEffect(() => {
    fetchPregnancies();
    fetchLabResults();
  }, []);

  const fetchPregnancies = async () => {
    try {
      const res = await axios.get(
        `https://clinic.salamatpayanew.ir/api/pregnancy/${propsData.nezam}/${propsData.meli}`
      );
      setPregnancies(res.data);

      if (res.data.length > 0 && res.data[0].lmp) {
        const latestLmp = res.data[0].lmp;
        const lmpMoment = moment(latestLmp, "YYYY-MM-DD");
        const daysDiff = moment().diff(lmpMoment, "days");
        const weeks = Math.floor(daysDiff / 7);
        const days = daysDiff % 7;
        setCurrentGa(`${weeks} هفته و ${days} روز`);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLabResults = async () => {
    try {
      const res = await axios.get(
        `https://clinic.salamatpayanew.ir/api/pregnancy/labresults/${propsData.nezam}/${propsData.meli}`
      );
      setLabHistory(res.data);
    } catch (err) {
      console.error("خطا در گرفتن آزمایش‌ها", err);
    }
  };

  const handleLmpChange = (date) => {
    setForm((prev) => ({ ...prev, lmp: date }));
    if (date) {
      const faDate = date.format("YYYY/MM/DD");
      const enDate = toEnglishNumber(faDate);
      const lmpMoment = moment(enDate, "jYYYY/jMM/jDD");

      const edc = lmpMoment.clone().add(280, "days").format("jYYYY/jMM/jDD");
      const now = moment();
      const daysDiff = now.diff(lmpMoment, "days");
      const weeks = Math.floor(daysDiff / 7);
      const days = daysDiff % 7;
      setGaEdc({ edc: edc, ga_weeks: `${weeks} هفته و ${days} روز` });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date) => {
    setForm((prev) => ({ ...prev, date: date }));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        nezam: propsData.nezam,
        meli: propsData.meli,
        name: propsData.name,
        year: propsData.year,
        lmp: form.lmp
          ? moment(toEnglishNumber(form.lmp.format("YYYY/MM/DD")), "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          : null,
        date: form.date
          ? moment(toEnglishNumber(form.date.format("YYYY/MM/DD")), "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          : null,
        edc:
          gaEdc.edc !== ""
            ? moment(toEnglishNumber(gaEdc.edc), "jYYYY/jMM/jDD").format("YYYY-MM-DD")
            : null,
        ga_weeks: gaEdc.ga_weeks,
      };
      await axios.post("https://clinic.salamatpayanew.ir/api/add-pregnancy", payload);
      fetchPregnancies();
      setForm({
        lmp: null,
        l: "",
        ab: "",
        p: "",
        g: "",
        note: "",
        hof: "",
        bp: "",
        wt: "",
        date: null,
        type: "",
        gender: "",
        fht:"",
      });
      setGaEdc({ edc: "", ga_weeks: "" });
    } catch (error) {
      console.error(error);
    }
  };

  const handleLabChange = (e) => {
    setLabData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLabSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://clinic.salamatpayanew.ir/api/pregnancy/labresults", {
        nezam: propsData.nezam,
        meli: propsData.meli,
        ...labData,
      });
      setLabData({});
      fetchLabResults();
    } catch (err) {
      alert("خطا در ثبت آزمایش");
    }
  };

   const [selectedNote, setSelectedNote] = useState(null);

   const getAge = (year) => {
    if (!year) return "";
    const currentYear = moment().year();
    return currentYear - parseInt(year);
  };
  
  const [showEditPregnancy, setShowEditPregnancy] = useState(false);

  const [editNote, setEditNote] = useState("");
  const [editNoteId, setEditNoteId] = useState(null);


  const handleNoteUpdate = async () => {
  try {
    await axios.put(`https://clinic.salamatpayanew.ir/api/pregnancy/update-note/${editNoteId}`, {
      note: editNote,
    });
    setSelectedNote(null);
    fetchPregnancies(); // تا اطلاعات جدید بارگذاری شود
  } catch (err) {
    alert("خطا در به‌روزرسانی توضیحات");
  }
};


return (
    <section className="m-0 content" dir="rtl">
      <div dir="rtl" className="container mt-4">
        {currentGa && (
          <div className="alert alert-info text-center fs-5">
            سن بارداری فعلی: {toPersianNumber(currentGa)}
          </div>
        )}

<div className="card shadow-sm border mb-4" dir="rtl">
  <div className="card-header bg-primary text-white text-center d-flex justify-content-between align-items-center">
    <h5 className="m-0 w-100 text-center">🩺 اطلاعات خلاصه بارداری</h5>
    <button
      className="btn btn-sm btn-light ms-2"
      title="ثبت اطلاعات جدید"
      onClick={() => setShowEditPregnancy(!showEditPregnancy)}
    >
      {showEditPregnancy ? "❌" : "➕"}
    </button>
  </div>

  <div className="card-body p-3">
    <div className="table-responsive">
      <table className="table table-bordered text-center align-middle mb-0">
        <tbody>
          <tr className="bg-light fw-bold">
            <td>👤 نام</td>
            <td>🎂 سن</td>
            <td>🩺 G</td>
            <td>🤰 P</td>
            <td>⚠️ AB</td>
            <td>👶 L</td>
          </tr>
          <tr>
            <td>{propsData.name}</td>
            <td>0</td>

            {showEditPregnancy ? (
              <>
                <td><input className="form-control text-center" name="g" value={form.g} onChange={handleChange} /></td>
                <td><input className="form-control text-center" name="p" value={form.p} onChange={handleChange} /></td>
                <td><input className="form-control text-center" name="ab" value={form.ab} onChange={handleChange} /></td>
                <td><input className="form-control text-center" name="l" value={form.l} onChange={handleChange} /></td>
              </>
            ) : (
              <>
                <td>{toPersianNumber(form.g || pregnancies[0]?.g || "-")}</td>
                <td>{toPersianNumber(form.p || pregnancies[0]?.p || "-")}</td>
                <td>{toPersianNumber(form.ab || pregnancies[0]?.ab || "-")}</td>
                <td>{toPersianNumber(form.l || pregnancies[0]?.l || "-")}</td>
              </>
            )}
          </tr>

          <tr className="bg-light fw-bold">
            <td>📅 LMP</td>
            <td>🗓️ EDC</td>
            <td colSpan="3">🕒 سن بارداری</td>
            <td>📌 کد نظام</td>
          </tr>
          <tr>
            {showEditPregnancy ? (
              <>
                <td>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    value={form.lmp}
                    onChange={val => setForm({ ...form, lmp: val })}
                    format="YYYY/MM/DD"
                    inputClass="form-control text-center"
                    calendarPosition="bottom-right"
                  />
                </td>
                <td>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    value={form.edc}
                    onChange={val => setForm({ ...form, edc: val })}
                    format="YYYY/MM/DD"
                    inputClass="form-control text-center"
                    calendarPosition="bottom-right"
                  />
                </td>
                <td colSpan="3">{/* سن بارداری محاسبه میشه بعد از ذخیره */}</td>
                <td>{propsData.nezam}</td>
              </>
            ) : (
              <>
                <td>
                  {form.lmp
                    ? form.lmp.format("YYYY/MM/DD")
                    : pregnancies[0]?.lmp
                      ? moment(pregnancies[0].lmp).format("jYYYY/jMM/jDD")
                      : "-"}
                </td>
                <td>
                  {gaEdc.edc
                    ? toPersianNumber(gaEdc.edc)
                    : pregnancies[0]?.edc
                      ? moment(pregnancies[0].edc).format("jYYYY/jMM/jDD")
                      : "-"}
                </td>
                <td colSpan="3">
                  {gaEdc.ga_weeks
                    ? toPersianNumber(gaEdc.ga_weeks)
                    : toPersianNumber(currentGa || "-")}
                </td>
                <td>{propsData.nezam}</td>
              </>
            )}
          </tr>
          
          {showEditPregnancy && (
            <tr>
{/*               <td colSpan="6">
                <div className="d-flex justify-content-end">
                  <button className="btn btn-success btn-sm me-2" onClick={handleSubmit}>💾 ذخیره</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => setShowEditPregnancy(false)}>لغو</button>
                </div>
              </td> */}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>

      <div className="card p-3">
          <h4 className="card-title text-center">فرم بارداری</h4>

         {/*  <label>تاریخ آخرین قاعدگی (LMP):</label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={form.lmp}
            onChange={handleLmpChange}
            format="YYYY/MM/DD"
            inputClass="form-control text-center"
            placeholder="تاریخ را انتخاب کنید"
            calendarPosition="bottom-right"
          />
 */}
{/*           {gaEdc.ga_weeks && (
            <div className="my-3">
              <div className="form-control text-center mb-2">
                سن بارداری: {toPersianNumber(gaEdc.ga_weeks)}
              </div>
              <div className="form-control text-center">
                تاریخ زایمان: {toPersianNumber(gaEdc.edc)}
              </div>
            </div>
          )} */}
         
          <input name="hof" onChange={handleChange} className="form-control mt-2" placeholder="HOF" />
          <input name="bp" onChange={handleChange} className="form-control mt-2" placeholder="BP" />
          <input name="wt" onChange={handleChange} className="form-control mt-2" placeholder="WT" />
          <input name="fht" onChange={handleChange} className="form-control mt-2" placeholder="FHT" />

{/*           <label className="mt-2">تاریخ (اختیاری):</label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={form.date}
            onChange={handleDateChange}
            format="YYYY/MM/DD"
            inputClass="form-control text-center"
            calendarPosition="bottom-right"
          /> */}

          <select name="type" onChange={handleChange} className="form-select mt-2">
            <option value="">نوع زایمان</option>
            <option value="طبیعی">طبیعی</option>
            <option value="سزارین">سزارین</option>
          </select>

          <select name="gender" onChange={handleChange} className="form-select mt-2">
            <option value="">جنسیت</option>
            <option value="پسر">پسر</option>
            <option value="دختر">دختر</option>
          </select>
          <input name="note" onChange={handleChange} className="form-control mt-2" placeholder="گزارش سونو - توضیحات" />
          <button className="btn btn-success w-100 mt-3" onClick={handleSubmit}>
            ذخیره فرم بارداری
          </button>
        </div>

        {pregnancies.length > 0 && (
        <table className="table table-bordered table-striped mt-4">
          <thead>
            <tr>
              <th>تاریخ مراجعه</th>
              <th>تاریخ پریودی</th>
              <th>سن بارداری</th>
              <th>EDC</th>
              <th>HOF</th>
              <th>FHT</th>
              <th>BP</th>
              <th>WT</th>
              <th>نوع زایمان</th>
              <th>جنسیت</th>
              <th>توضیحات</th>
            </tr>
          </thead>
          <tbody>
            {pregnancies.map((row, idx) => (
              <tr key={idx}>
                <td>{row.created_at ? moment(row.created_at).format("jYYYY/jMM/jDD") : ""}</td>
                <td>{row.lmp ? moment(row.lmp).format("jYYYY/jMM/jDD") : ""}</td>
                <td>{toPersianNumber(currentGa)}</td>
                <td>{row.edc ? moment(row.edc).format("jYYYY/jMM/jDD") : ""}</td>
                <td>{row.hof}</td>
                <td>{row.fht}</td>
                <td>{row.bp}</td>
                <td>{row.wt}</td>
                <td>{row.type}</td>
                <td>{row.gender}</td>
                <td>
                  {row.note?.length > 3 ? (
                    <>
                      {row.note.substring(0, 5)}...
                      <button
                        className="btn btn-sm btn-link p-0 ms-2"
                        onClick={() => {
                          setEditNote(row.note);
                          setEditNoteId(row.id);
                          setSelectedNote("edit");
                        }}
                      >
                        نمایش
                      </button>
                    </>
                  ) : (
                    row.note
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

{selectedNote === "edit" && (
  <div
    className="modal fade show d-flex align-items-center justify-content-center"
    style={{
      display: "flex",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1050,
    }}
    tabIndex="-1"
  >
    <div className="modal-dialog modal-lg" style={{ maxWidth: "800px", width: "100%" }}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">ویرایش توضیحات</h5>
          <button type="button" className="btn-close" onClick={() => setSelectedNote(null)}></button>
        </div>
        <div className="modal-body">
          <textarea
            className="form-control"
            value={editNote}
            onChange={(e) => setEditNote(e.target.value)}
            style={{
              minHeight: "300px",
              height: "100%",
              width: "100%",
              resize: "none",
              fontSize: "1.1rem",
              lineHeight: "1.6",
            }}
            placeholder="متن توضیحات را وارد کنید..."
          />
        </div>
        <div className="modal-footer d-flex justify-content-between">
          <button className="btn btn-success" onClick={handleNoteUpdate}>💾 ذخیره</button>
          <button className="btn btn-secondary" onClick={() => setSelectedNote(null)}>❌ بستن</button>
        </div>
      </div>
    </div>
  </div>
)}

        {/* ✅ فرم و جدول آزمایش‌ها */}
        <div className="card p-3 mt-5">
          <h5 className="mb-3">ثبت آزمایش‌ها</h5>
          <form className="row g-2" onSubmit={handleLabSubmit}>
            {["dateold","hb","rpr","bg_rh","fbs","gtt","hiv","uc","ua","hbs","bun","cr","hcv","plt","tsh","vitd3","ict","ferritin","rubella","rub_igg"].map((key) => (
              <div className="col-md-3" key={key}>
                <input
                  name={key}
                  value={labData[key] || ""}
                  onChange={handleLabChange}
                  placeholder={key.toUpperCase()}
                  className="form-control"
                />
              </div>
            ))}
            <div className="col-12">
              <button className="btn btn-primary w-100" type="submit">ثبت آزمایش</button>
            </div>
          </form>

          <table className="table table-striped mt-4">
            <thead>
              <tr>
              {/*   <th>تاریخ</th> */}
                <th>تاریخ آزمایش</th>
                <th>HB</th>
                <th>RPR</th>
                <th>BG+RH</th>
                <th>FBS</th>
                <th>GTT</th>
                <th>HIV</th>
                <th>UA</th>
                <th>UC</th>
                <th>TSH</th>
              </tr>
            </thead>
            <tbody>
              {labHistory.map((row, idx) => (
                <tr key={idx}>
               {/*    <td>{moment(row.created_at).format("jYYYY/jMM/jDD")}</td> */}
                  <td>{row.dateold}</td>
                  <td>{row.hb}</td>
                  <td>{row.rpr}</td>
                  <td>{row.bg_rh}</td>
                  <td>{row.fbs}</td>
                  <td>{row.gtt}</td>
                  <td>{row.hiv}</td>
                  <td>{row.ua}</td>
                  <td>{row.uc}</td>
                  <td>{row.tsh}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};